import { ActionType } from '../constants/ActionTypes'

export default function bonusReducerV2(state = {
    loading: true
}, action = {}) {
    switch (action.type) {
        case ActionType.GET_BONUSES:
            return {
                ...state,
                ...action.payload,
            }
        case ActionType.SET_BONUSES_LOADING:
            return {
                ...state,
                loading: action.payload
             }
        case ActionType.GET_BONUS_ITEM_DETAILS_SUCCESS:
            return {
                ...state,
                details: action.payload
             }
             
        case ActionType.GET_BONUS_PRODUCTS_V2_SUCCESS:
            return {
                ...state,
                products: {
                    ...state.products, 
                    entries: action.payload.resetData ? action.payload.data.entries : [...state.products.entries, ...action.payload.data.entries],
                    hasNext: action.payload.data.hasNext,
                    gameCount: action.payload.data.gameCount
                },
                productsLoading: false
            } 
        case ActionType.GET_BONUS_HISTORY_V2_SUCCESS:
            return {
                ...state,
                historyData: {...action.payload.data},
            } 
        default:
            return state;
    }
}